import { useEffect, useState } from "react";
import { getRadonByPostinumero } from "../../../api/api";
import { useReportTemplateContext } from "../ReportTemplate/ReportTemplateContext";

const GREEN = "#04aa00";
const LIGHT_GREY = "#f0f0f0";
const WHITE = "#ffffff";

export default function RadonBlock() {
  const { rakennusData: kiinteisto } =
    useReportTemplateContext();

  const rakennukset =
    kiinteisto?.rakennukset_fulls ||
    kiinteisto?.rakennukset ||
    [];

  const postinumero =
    rakennukset?.[0]?.postinumero ||
    kiinteisto?.postinumero ||
    null;

  const [radonData, setRadonData] = useState(null);
  const [hiddenRadonRows] = useState([]);

  useEffect(() => {
    if (!postinumero) {
      setRadonData(null);
      return;
    }

    let isMounted = true;

    const fetchRadon = async () => {
      try {
        const response =
          await getRadonByPostinumero(postinumero);

        if (isMounted) {
          // Only take postal-code radon data
          setRadonData(
            response.data?.postinumero || null
          );
        }
      } catch (error) {
        console.error(
          "Radondatan haku epäonnistui:",
          error
        );

        if (isMounted) {
          setRadonData(null);
        }
      }
    };

    fetchRadon();

    return () => {
      isMounted = false;
    };
  }, [postinumero]);

  const RADON_ROWS = [
    {
      key: "Postinumero",
      label: "Postinumero",
      value: radonData?.Postinumero
    },
    {
      key: "Postitoimipaikka",
      label: "Postitoimipaikka",
      value: radonData?.Postitoimipaikka
    },
    {
      key: "mitattuja",
      label: "Mitattuja pientaloasuntoja",
      value:
        radonData?.["Mitattuja pientaloasuntoja"]
    },
    {
      key: "Mediaani",
      label: "Mediaani (Bq/m³)",
      value:
        radonData?.["Mediaani  Bq/m3"]
    },
    {
      key: "Keskiarvo",
      label: "Keskimääräinen radon (Bq/m³)",
      value:
        radonData?.["Keskiarvo Bq/m3"]
    },
    {
      key: "200",
      label: "200 Bq/m³ ylitykset (%)",
      value:
        radonData?.["200 Bq/m3 ylitykset %"]
    },
    {
      key: "300",
      label: "300 Bq/m³ ylitykset (%)",
      value:
        radonData?.["300 Bq/m3 ylitykset %"]
    },
    {
      key: "1000",
      label: "1000 Bq/m³ ylitykset (%)",
      value:
        radonData?.["1000 Bq/m3 ylitykset %"]
    }
  ];

  const renderValue = value => {
    if (
      value === null ||
      value === undefined ||
      value === ""
    ) {
      return "–";
    }

    return String(value);
  };

  return (
    <div
      className="rounded border overflow-hidden"
      style={{
        backgroundColor: WHITE,
        borderColor: "#e9f0ec"
      }}
    >
      <section>
        <div
          className="px-3 py-2 fw-bold text-white"
          style={{
            backgroundColor: GREEN
          }}
        >
          Radon – postinumeroalue
        </div>

        {radonData ? (
          <table className="table table-sm mb-0">
            <tbody>
              {RADON_ROWS
                .filter(
                  row =>
                    !hiddenRadonRows.includes(row.key)
                )
                .map((row, index) => {
                  const rowBackground =
                    index % 2 === 0
                      ? LIGHT_GREY
                      : WHITE;

                  return (
                    <tr key={row.key}>
                      <th
                        className="px-3 py-2 fw-normal"
                        style={{
                          width: "42%",
                          backgroundColor:
                            rowBackground,
                          border: 0
                        }}
                      >
                        {row.label}
                      </th>

                      <td
                        className="px-3 py-2"
                        style={{
                          backgroundColor:
                            rowBackground,
                          border: 0
                        }}
                      >
                        {renderValue(row.value)}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        ) : (
          <div
            className="px-3 py-2 text-muted"
            style={{
              backgroundColor: WHITE
            }}
          >
            Ei radondataa postinumerolle{" "}
            {postinumero || "–"}.
          </div>
        )}
      </section>
    </div>
  );
}